/* eslint-disable */

class Utils {
  constructor() {}
  GenerateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  First(array, delegate) {
    for (const iterator of array) {
      if (delegate(iterator)) return iterator;
    }
  }
  Capitalize(c) {
    return c[0].toUpperCase() + c.substr(1, c.length);
  }
  RandomBetween0AndN(N) {
    return Math.floor(Math.random() * N);
  }
  NumberWith0(n) {
    let result = "";
    if (typeof n === Number || parseInt(n) !== NaN) {
      if (n < 10) result = "0" + n;
      else result = n + "";
    }
    return result;
  }
  ToStars(val) {
    var result = "";
    for (let index = 0; index < val.length; index++) {
      result += "*";
    }
    return result;
  }
  MinLengthValidate = (v, l) => (v !== null ? v.length >= l : false);
  ImageLoad(file, callback) {
    let FR = new FileReader();
    var image = new Image();
    FR.addEventListener("load", function(e) {
      image.src = e.target.result;
    });
    FR.readAsDataURL(file);
    // last event for checks
    image.addEventListener("load", function() {
      callback(this, file);
    });
  }
  validateUrl = url =>
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      url
    );
  ValidateCF = cf =>
    /[a-z]{6}\d{2}[abcdehlmprst]\d{2}[a-z]\d{3}[a-z]/i.test(cf);
  ValidateEmail = mail => /.+@.+\..+/i.test(mail);
  ValidateNumber = num => /^[0-9]+$/i.test(num);
  GetCountdown(date, cbk) {
    return setInterval(function() {
      let d = new Date().getTime() - new Date(date).getTime();
      let days = Math.floor(d / (1000 * 60 * 60 * 24));
      let hours = Math.floor((d % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((d % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((d % (1000 * 60)) / 1000);
      if (cbk !== undefined) cbk({ d: days, h: hours, m: minutes, s: seconds });
    });
  }
  getDayName = day => {
    switch (day) {
      case 0:
        return "Domenica";
      case 1:
        return "Lunedì";
      case 2:
        return "Martedì";
      case 3:
        return "Mercoledì";
      case 4:
        return "Giovedì";
      case 5:
        return "Venerdì";
      case 6:
        return "Sabato";
    }
  };
  getMonthName = m => {
    switch (m) {
      case "01":
        return "Gennaio";
      case "02":
        return "Febbraio";
      case "03":
        return "Marzo";
      case "04":
        return "Aprile";
      case "05":
        return "Maggio";
      case "06":
        return "Giugno";
      case "07":
        return "Luglio";
      case "08":
        return "Agosto";
      case "09":
        return "Settembre";
      case "10":
        return "Ottobre";
      case "11":
        return "Novembre";
      case "12":
        return "Dicembre";
    }
  };
  ClearCountdown = ctd => clearInterval(ctd);
  getFileExtension = str => {
    var fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim;
    return str.match(fileExtensionPattern)[0];
  };
  getMime = str => {
    switch (str.toLowerCase()) {
      case ".jpg":
      case ".jpeg":
        return "image/jpeg";
      case ".png":
        return "image/png";
      case ".gif":
        return "image/gif";
    }
  };
  data2blob = (data, ext) => {
    data = data.split(",")[1];
    data = window.atob(data);
    var ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i);
    }
    return new Blob([ia], {
      type: this.getMime(ext)
    });
  };
  getCookie = cookiename => {
    // Get name followed by anything except a semicolon
    var cookiestring = RegExp("" + cookiename + "[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    return decodeURIComponent(
      !!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : ""
    );
  };
  getRandomColorByHash(input) {
    let hash = 0;
    if (input) {
      for (let i = 0; i < input.length; i++) {
        const charCode = input.charCodeAt(i);
        hash = (hash << 5) - hash + charCode;
        hash &= hash; // converti a 32-bit integer
      }
    }

    // Converti il risultato in una stringa esadecimale
    let result = (hash & 0x00ffffff).toString(16).toUpperCase();
    let color = `#${"00000".concat(result).slice(-6)}`;

    // Funzione per calcolare la luminosità
    function getLuminance(hex) {
      hex = hex.replace("#", "");
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      return 0.299 * r + 0.587 * g + 0.114 * b; // formula luminosità percepita
    }

    // Funzione per schiarire forzando la luminosità minima
    function adjustBrightness(color, targetLum = 180) {
      let hex = color.replace("#", "");
      let r = parseInt(hex.substr(0, 2), 16);
      let g = parseInt(hex.substr(2, 2), 16);
      let b = parseInt(hex.substr(4, 2), 16);

      let currentLum = getLuminance(color);
      if (currentLum >= targetLum) return color;

      let factor = targetLum / currentLum; // calcola quanto schiarire
      r = Math.min(255, Math.floor(r * factor));
      g = Math.min(255, Math.floor(g * factor));
      b = Math.min(255, Math.floor(b * factor));

      return (
        "#" +
        r.toString(16).padStart(2, "0") +
        g.toString(16).padStart(2, "0") +
        b.toString(16).padStart(2, "0")
      );
    }

    // Schiarisci il colore se necessario
    color = adjustBrightness(color, 180);

    return color;
  };
  itaDate(date) {
    let d = new Date(date);
    return (
      this.NumberWith0(d.getDate()) +
      "/" +
      this.NumberWith0(d.getMonth() + 1) +
      "/" +
      d.getFullYear()
    );
  }
}

export default Utils;
String.prototype.trunc = function(n) {
  return this.substr(0, n - 1) + (this.length > n ? "..." : "");
};



// WEBPACK FOOTER //
// ./src/utils.js